module.exports = __webpack_public_path__ + "static/media/dolly-flatbed-alt.f42203a6.svg";